import { Loading, LoadingMessageProps } from "./Loading";

export const LinearLoading = (props: LoadingMessageProps) => {
  return <Loading {...props} loading={<div className="dot-flashing " />} />;
};
